export default "__VITE_ASSET__CNYVQZ7B__"